import React, { Component } from 'react';
import ApproveContent from '../component/ApproveContent.js'; //component that contains each table row for each thankyou to be approved
import TableHead from '../component/TableHead.js'; //component that contains the title of each column in the table
import axios from 'axios';
import {path,mail} from './routes.js';
import Modal from 'react-modal';
import Input from '../component/Input.js';
import Submit from '../component/Submit.js';
import sparkles2 from '../asset/img/sparkles2.png';
import Validation from './Validation.js'; //used for validation
import loader from '../asset/img/loader.gif';

export default class ApproveThankyous extends Component{
	constructor(props){
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.state = {
			modalIsOpen:false,
			thankyous:[{ID:'',userID:'',info:{"To":"","From":"","Reason":"","Value":"","Date":""}}],
			denialReason:'',
			parameters:{},
			modalType:'',
			data:'',
			manager:'',
			requiredPrompt:'Required',
			loading: false,
			loadingMessage: ''
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.sendInfo = this.sendInfo.bind(this);
		this.sendDenialReason = this.sendDenialReason.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.handleDenial = this.handleDenial.bind(this);
		this.handleReview = this.handleReview.bind(this);
		this.editThankyou = this.editThankyou.bind(this);
		this.bulkApprove = this.bulkApprove.bind(this);
	}

	bulkApprove(){
		this.setState({loading: true});
		const emailData = this.state.thankyous.map(thank => {
			return ({
				'action': 'received',
				'name': thank.info.To,
				'from': thank.info.From,
				'reason': thank.info.Reason,
				'date': thank.info.Date,
				'virtue': thank.info.Value
			});
		});
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{endpoint:'create',table:'thank',misc:'bulk_approve', emailData: emailData}
		}).then((response)=>{
			this.setState({loadingMessage: 'Success!'}, ()=>{
				setTimeout(() => this.setState({thankyous: [], loading: false, loadingMessage: ''}), 2000);
			});
		}).catch(err => {
			this.setState({loadingMessage: 'A problem has occured while attempting the bulk approval of thank yous.'}, ()=>{
				setTimeout(() => this.setState({loading: false, loadingMessage: ''}), 4000);
			});
		});
	}

	sendInfo(params){ //this method is for emailing either a thank you recipient or a manager
		axios({
				method:'post',
				url:path,
				headers:{'Content-Type':'application/json'},
				data:params
			}).then((response)=>{
					let data;
					let email = response.data.data[0].email;
					let username = response.data.data[0].name;
					if(params.action === "thankyouDenied"){
						let reason = this.state.denialReason.replace(/(?:\r\n|\r|\n)/g, '<br>');
						data = {'action':params.action,'email':email,'name':username,'reason':reason};
					}else{
						data = {'action':params.action,'email':email,'name':username,'from':params.from,'reason':params.reason,'date':params.date,'virtue':params.virtue};
					}
					axios({
						method:'post',
						url:mail,
						headers:{'Content-Type':'application/json'},
						data:data
					});
			});
	}

	sendDenialReason(){ //this method is used when a thankyou is denied, sending an email notifying whomever sent the thankyou with info on why it was denied
		if(this.state.denialReason.trim() !== '' && Validation("reason",this.state.denialReason.trim())){
			let data = this.state.data;
			let thankId = data.firstID;
			const newState = this.state.thankyous.filter((thank)=>{
				if(Number(thank.ID) !== Number(thankId)){
					return thank;
				}
			});
			this.setState({modalIsOpen:false,modalType:''},function(){
				this.sendInfo(this.state.parameters);
			});
			
			this.handleDenial(newState,data);
		}else{
			let prompt;
			if(this.state.denialReason.trim() !== ''){
				prompt = "Contains invalid characters";
			}else{
				prompt = "Required";
			}
			this.setState({requiredPrompt:prompt});
		}
	}

	handleDenial(newState,data){  //this method handles updating the status of the thank you in the database and removing it from the current state
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:data
		}).then((response)=>{ //if status was successfully updated, remove from the state.
			let data = response.data.data;
			if(data.Message === "Success"){
				this.setState({thankyous:newState});
			}
		});
	}

	handleReview(){ //method handles updating the status of the thankyou in the database and updates the state
		let params = this.state.parameters;
		let data = this.state.data;
		let thankId = data.firstID;
		const newState = this.state.thankyous.filter((thank)=>{
			if(Number(thank.ID) !== Number(thankId)){
				return thank;
			}
		});
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:data
		}).then((response)=>{
			let data = response.data.data;
			if(data.Message === "Success"){ //if status was successfully updated, remove from state, send notification
				this.setState({thankyous:newState});
				this.sendInfo(params);
			}
		});
		this.closeModal();
	}

	handleClick(val,thankId){ //method for handling operations after the approve, review, or deny button is clicked for a thankyou
		let userID;
		let date;
		let name;
		let _from;
		let reason;
		let virtue;
		const newState = this.state.thankyous.filter((thank)=>{ //filter out and get needed information from the thank you that has been either approved, sent for review, or denied
			if(thank.ID !== thankId){
				return thank;
			}else{
				userID = thank.userID;
				date = thank.info.Date;
				name = thank.info.To;
				_from = thank.info.From;
				date = thank.info.Date;
				reason = thank.info.Reason;
				virtue = thank.info.Value;
			}
		});
		this.setState({data:{endpoint:'create',table:'thank',misc:'status',firstID:thankId,secondID:userID,status:val,date:date,name:name}});
		let action;
		let params;
		if(val !== "denied"){
			if(val === "review"){ //handles updating a thank you and preparing parameters for email if the thank you needs further review
				action = 'manager';
				name = null;
				_from = null;
				date = null;
				reason = null;
				virtue = null;
				params = {endpoint:'info',table:'users',action:action,userID:userID,name:name,from:_from,date:date,reason:reason,virtue:virtue};
				axios({
					method:'post',
					url:path,
					headers:{'Content-Type':'application/json'},
					data:params
				}).then((response)=>{
					this.setState({parameters:params,modalType:'review',manager:response.data.data[0].name},function(){
						this.openModal();
					});
				});
				
			}else if (val === "approved"){ //handles updating a thank you and preparing parameters for email if the thank you has been approved
				
				axios({
					method:'post',
					url:path,
					headers:{'Content-Type':'application/json'},
					data:{endpoint:'create',table:'thank',misc:'status',firstID:thankId,secondID:userID,status:val,date:date,name:name}
				}).then((response)=>{
					let data = response.data.data;
					if(data.Message === "Success"){
						this.setState({thankyous:newState});
						action = 'received';
						userID = null;
						params = {endpoint:'info',table:'users',action:action,userID:userID,name:name,from:_from,date:date,reason:reason,virtue:virtue};
						this.sendInfo(params);
					}
				});
			}
			
		}else if(val === "denied"){  //handles updating a thank you and preparing parameters for email if the thank you has been denied
			action = 'thankyouDenied';
			name = null;
			params = {endpoint:'info',table:'users',action:action,userID:userID,name:name};
			this.setState({parameters:params,modalType:'denied'},function(){
				this.setState({modalIsOpen:true});
			});
		}

	}

	componentDidMount(){ //determines which thank yous to retrieve from database based on user type and then retrieves them
		let status;
		if (this.props.userInfo.userType === "admin" || this.props.userInfo.userType === "sys_admin"){
			status = "pending";
		}else{
			status = "review";
		}
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data: {endpoint:'info',table:'thankyous',action:status,name:this.props.userInfo.userID}
		}).then((response)=>{

			let thanks = [];
			let res = response.data.data;
			res.forEach((thankyou)=>{
				thanks.push({ID:thankyou.ID,userID:thankyou.userID,info:{To:thankyou.To,From:thankyou.From,Reason:thankyou.Reason,Value:thankyou.Value,Date:thankyou.Date}});
			});
			this.setState({thankyous:thanks});
		});
	}

	openModal() { //method for opening modal
    	this.setState({modalIsOpen: true});
  }

	closeModal() { //method for closing the modal
	    this.setState({modalIsOpen: false,requiredPrompt:'Required'});
	}

	handleInput(identity,value){	//handles input of the reason for denial is a thank you has been denied
			this.setState({denialReason:value});
	}

	editThankyou(e){
		let id = e.target.id;
		let text = document.getElementById(id).textContent;
		let thankyouInfo = id.split("_");
		let thankyouID = thankyouInfo[0];
		let thankyouIndex = thankyouInfo[2];
		let thankyous = this.state.thankyous;
		thankyous[thankyouIndex].info.Reason = text;
		this.setState({thankyous:thankyous});
		if(Validation("reason",text)){
			document.getElementById(id+"_td").style.borderColor = "green";
			document.getElementById(id+"_td").style.borderWidth="3px";
			axios({
				method:'post',
				url:path,
				headers:{'Content-Type':'application/json'},
				data:{endpoint:'create',table:'thank',misc:'edit',firstID:thankyouID,desc:text}
			});
		}
	}

	render(){
		let content;
		let modalContent;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    maxWidth:'500px',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '280px 252px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)',
			}
		};
		const objkeys = ["To","From","Reason","Value","Date","Action"];
		const thankyous = this.state.thankyous;
		const	colData = thankyous.map((thankyous,i) => { //each thank you is formatted and displayed as a line in a table, handled by the ApproveContent module
				return(
					<ApproveContent key={thankyous.ID} child={i} edit={this.editThankyou} identity={thankyous.ID} user={this.props.userInfo.userType} columns={thankyous.info} click={this.handleClick} kind="thankyou"/>
			)});
		if(this.state.modalType === 'denied'){ //if else statement, first if is for thank you denial
			modalContent = <div className="center pb3">
					        	<p className="b navy">Reason for denial: <span className="red f5"><span className="red f4 b">*</span>{this.state.requiredPrompt}</span></p>
					        	<Input type="area" styles="pa2 br2 bw1 w-100-ns w-100 h3" onInput={this.handleInput} identity="reason"/>
					        	<div className="pt2">
					        		<Submit name="Submit" onClick={this.sendDenialReason} styles="br2 white b w-40 h2 bg-blue"/>
					        	</div>
					        </div>;
		}else{ //this block is for marking a thank you for review
			modalContent = <div className="fl w-100">
					        	<div>
					        		<p className="b navy tc">Are you sure you would like to send this thank you to {this.state.manager} for review?</p>
					        	</div>
					        	<div className="fl w-100">
					        		<div className="fl w-50 tc">
					        			<button onClick={this.handleReview} className="w-50-ns w-100 bg-navy b white br2">Yes</button>
					        		</div>
					        		<div className="fl w-50 tc">
					        			<button onClick={this.closeModal} className="w-50-ns w-100 bg-navy b white br2">No</button>
					        		</div>
					        	</div>
					        </div>;
		}
		if(this.props.active){
			if(this.state.thankyous.length !== 0){
				content= <div style={{margin:'auto',boxShadow: '3px 3px 5px 3px #888888'}} className="br3 br--top shadow-3 w-100 tc">
									<table className="w-100 collapse br3 bg-white tc">
										<thead className="collapse h2 bg-white br3">
											<TableHead columns={objkeys} headstyle="pa2 br3 bg-white"/>
										</thead>
										<tbody>
											{colData}
											
										</tbody>
									</table>
									<button id="approve-all" className="shadow-3" onClick={this.bulkApprove}>Approve All</button>
									<div>
										<Modal
											isOpen={this.state.modalIsOpen}
											style={customStyles}
											contentLabel="Denial Reason"
											shouldCloseOnOverlayClick={false}
											shouldCloseOnEsc={false}
										>
											<div className="fl w-100 tr">
												<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
											</div>
											{modalContent}
										</Modal>
									</div>
									<div>
										<Modal
											isOpen={this.state.loading}
											style={customStyles}
											contentLabel="loading"
											shouldCloseOnOverlayClick={false}
											shouldCloseOnEsc={false}
										>
											<div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
										</Modal>
									</div>
								</div>;
			}else{
				content = <p className="w-100 f3 tc">There is nothing to view at this time.</p>;
			}
		}
		return(
			<div>
			{content}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ApproveThankyous.js